import React, { useEffect } from "react";
import Footer from "./Footer";
import NavBar from "./Navbar";
import Iframe from "react-iframe";
import useExternalScripts from "./useExternalScripts";
import style from "./styledContainers/Reservaciones.module.css"
import DateRangeSelector from "./Engine2";
const Reservas = () => {

    useExternalScripts("https://frame2.hotelpms.io/BookingFrameClient/public/assets/booking-frame/js/iframe-resizer.min.js")
    useExternalScripts("https://frame2.hotelpms.io/BookingFrameClient/public/assets/booking-frame/js/main.js")


    return (
        <div>
        <NavBar/>
        <DateRangeSelector/>
       

        
        <Iframe className={style.BookingFrame} id="hw-booking-frame"
    src="https://frame2.hotelpms.io/BookingFrameClient/hotel/ADD751F4EC3E1738F788091E1CE9F0AF/3cc584c0-a3f6-4720-bb39-cbde03a3a2db/book/rooms?currency=COP&language=es-ES&rp="
    frameborder="0" allowtransparency="true" scrolling="no" style="width: 100%;">
</Iframe>


        <Footer/>
        </div>
    
    )
}

export default Reservas



